const forms = {
  state: {
    statsRemote: null,
    companyStats: null,
    facilityStats: null,
    assetStats: null,
    userStats: null
  },
  mutations: {
    changeStatsRemote(state, payload) {
      state.statsRemote = payload;
    },
    changeCompanyStats(state, payload) {
      state.companyStats = payload;
    },
    changeFacilityStats(state, payload) {
      state.facilityStats = payload;
    },
    changeAssetStats(state, payload) {
      state.assetStats = payload;
    },
    changeUserStats(state, payload) {
      state.userStats = payload;
    }
  },
  actions: {
    changeStatsRemote({ commit }, payload) {
      commit("changeStatsRemote", payload);
    },
    changeCompanyStats({ commit }, payload) {
      commit("changeCompanyStats", payload);
    },
    changeFacilityStats({ commit }, payload) {
      commit("changeFacilityStats", payload);
    },
    changeAssetStats({ commit }, payload) {
      commit("changeAssetStats", payload);
    },
    changeUserStats({ commit }, payload) {
      commit("changeUserStats", payload);
    }
  },
  getters: {
    getStatsRemote: state => {
      return state.statsRemote;
    },
    getCompanyRelps: state => {
      return state.companyStats;
    },
    getFacilityRelps: state => {
      return state.facilityStats;
    },
    getAssetRelps: state => {
      return state.assetStats;
    },
    getUserRelps: state => {
      return state.userStats;
    }
  }
};
// eslint-disable-next-line
export default forms;
